export default __webpack_public_path__ + "static/media/a1.290418cf.jpeg";